export const INITIAL_STATE = {
    cityFilter: {
        cityIds: [],
    },
};
